import { getParameterByName } from "../utils/getParameterByName";

let debug = true; //localStorage.getItem('gc_debug') //Enables user to set debug mode
let gc_region = getParameterByName("gc_region");
let gc_clientId = getParameterByName("gc_clientId");
let gc_redirectUrl = getParameterByName("gc_redirectUrl");
let gc_conversationId = getParameterByName("gc_conversationId");
let gc_deploymentId = getParameterByName("gc_deploymentId");

//Getting and setting the GC details from dynamic URL and session storage
if (gc_region) {
  sessionStorage.setItem("gc_region", gc_region);
  if (debug) console.log("gc_region Saved: ", gc_region);
} else {
  gc_region = sessionStorage.getItem("gc_region");
  if (debug) console.log("gc_region retreived: ", gc_region);
}
if (gc_clientId) {
  sessionStorage.setItem("gc_clientId", gc_clientId);
  if (debug) console.log("gc_clientId Saved: ", gc_clientId);
} else {
  gc_clientId = sessionStorage.getItem("gc_clientId");
  if (debug) console.log("gc_clientId retreived: ", gc_clientId);
}
if (gc_redirectUrl) {
  sessionStorage.setItem("gc_redirectUrl", gc_redirectUrl);
  if (debug) console.log("gc_redirectUrl Saved: ", gc_redirectUrl);
} else {
  gc_redirectUrl = sessionStorage.getItem("gc_redirectUrl");
  if (debug) console.log("gc_redirectUrl retreived: ", gc_redirectUrl);
}
if (gc_conversationId) {
  sessionStorage.setItem("gc_conversationId", gc_conversationId);
  if (debug) console.log("gc_conversationId Saved: ", gc_conversationId);
} else {
  gc_conversationId = sessionStorage.getItem("gc_conversationId");
  if (debug) console.log("gc_conversationId retreived: ", gc_conversationId);
}
if (gc_deploymentId) {
  sessionStorage.setItem("gc_deploymentId", gc_deploymentId);
  if (debug) console.log("gc_deploymentId Saved: ", gc_deploymentId);
} else {
  gc_deploymentId = sessionStorage.getItem("gc_deploymentId");
  if (debug) console.log("gc_deploymentId retreived: ", gc_deploymentId);
}

export const clientConfig = {
  debug: debug,
  clientId: gc_clientId,
  redirectUri: gc_redirectUrl,
  region: gc_region,
  conversationId: gc_conversationId,
  deploymentId: gc_deploymentId,
};
